module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("2")])])]), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Familiar Territory")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("T")])])])]), _vm._v("he floor was cold, but the air was hot and too bright. Instinctively, Cyrus flinched from the sunlight touching his flesh.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His naked, human flesh.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How humiliating. He didn’t have the energy to rail against the indignation. Fatigue plagued his bones, and hunger gnawed his guts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As a vampire, he’d equated his need for blood with hunger, but it had been far more than physical desire. Blood hunger was a need for emotional fulfillment, the urge to indulge the most primal drive of his kind. To kill. To control. Human hunger was sadistic in its simplicity. Purely physical agony he hadn’t felt in centuries.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What had happened to him?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He winced as he sat up, his muscles screaming in protest, and he collapsed again. Around him, he could make out a cavernous darkness. Above him, a cone of sunlight streamed down, casting a circle of protection, as Dahlia would have called it. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Dahlia.")])]), _vm._v(" If she’d had anything to do with this he would rip her pretty little head off her fat shoulders, human or not. As soon as he recovered, he was certain his rage would give him strength enough to take on a whole army of vampire witches.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There were voices in the darkness, but he couldn’t see who they belonged to. Though his vision hadn’t cleared, it was far better than it had been when he’d been dead.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Dead. Carrie.")])]), _vm._v(" The pain of her betrayal came back with surprising ferocity. She’d refused his love, refused his blood. Then she’d plunged a knife through his heart without conscience. He could have almost admired that, if he hadn’t been on the losing end.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Closing his eyes, he lay on the hard, cold floor. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Marble,")])]), _vm._v(" he thought. It was funny how things were coming back to him now, piece by piece. Perhaps that was proof of a soul. Memory of past lives. Dahlia had always insisted her soul had lived several lives as assorted notorious historical figures. No, he wouldn’t start believing in a soul now. It would make the whole situation that much more ridiculous.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Like the unpleasant stretched sensation in his lower abdomen. He hadn’t felt that in months, but the meaning came back to him effortlessly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hello?” he called to the voices in the darkness, though a crude American “Hey!” might have been more appropriate, considering what they’d done to him. “I need to go to the toilet.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The voices bickered quietly among themselves, growing in intensity until someone shouted and broke the tension. “Well, then you go and get her!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who?” Cyrus cried, but the noise from the darkness swallowed his words. He sincerely hoped the “her” in question wasn’t one of the pair of vampires that had pulled him back. One had possessed a voice that would put a banshee to shame, and the other had been so gruff and masculine he’d thought for a moment she was a man.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A door scraped open, then slammed shut. A bloodcurdling scream of terror set off sparks of nostalgia in Cyrus’s heart, and the door screeched open again. The "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("her")])]), _vm._v(" in question was apparently terrified. It gave him little satisfaction, as he wasn’t terribly safe and secure himself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Get moving, bitch,” a distorted voice commanded from the shadows.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A shape moved out of the darkness, pale and waifish. As she moved closer, colors swam together. The muted yellow of her dress faded into the plain brown of her hair and her paper-white skin. Blood red splashed across her torso, and ugly purple, black and blue scored her throat and ringed her eye.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She approached warily, halting about two paces from him, and knelt at his side. The sunlight touched her, but she did not burn. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Human.")])]), _vm._v(" His relief was palpable. He did not want to be food for the creatures he’d once ruled over.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m here to help you,” she said, her voice barely a whisper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cyrus looked her over in disdain. He couldn’t stand soft-spoken women. They held no interest for him, and he considered anything that didn’t amuse him extraneous. He reached a shaking hand to push her hair from her face, and touched the dark bruise marring her eye. “I see you don’t listen well.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her hands clenched to angry fists, earning his respect for a moment. Then she flinched and destroyed the illusion of courage. This wasn’t the first black eye she’d received, he knew.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hang on to me,” she whispered, helping him to his feet. “They said you wouldn’t be able to walk.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How humiliating. He’d been deadly and powerful. Now, he was human. The vampires lurking in the shadows knew it. Though they kept their distance, their eagerness was palpable. He knew what he would feel in their place. Desire, curiosity. Not many vampires returned from the dead that he was aware of. That fact alone made him a delicacy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One of the vampires snarled. Cyrus heard the jingle of chains as the creature approached, and he tensed. At his side, the girl quivered and shrieked. If he could have stood on his own, he would have thrown her to them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’s not to be harmed!” another vampire commanded, and the one advancing backed down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Where am I?” Cyrus asked, hating himself for relying on this girl.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“St. Anne’s,” she whispered. “A church.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I gathered that. There are so few St. Anne’s car washes these days.” The door scraped open, and he gagged at the stench of death he used to revel in. He looked past the line of gleaming chrome motorcycles parked in the church vestibule, his eyes struggling to focus amid so much detail.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They said they were going to bury them after the sun went down,” the girl said quietly. “They never did.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cyrus squinted at the tangled forms of two bodies on the carpet. One was dressed in black with a cleric’s collar. The other was a woman with white hair, her button-down blouse and matronly cardigan slashed open to reveal the wrinkled skin of her chest. Her skirt tangled around her thighs, showing the tops of her knee-high stockings.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Father Bart and Sister Helen,” the girl whispered tearfully. “They—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know what they did to her.” He turned his head and reached for the wall for support. “Cover her up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hello, conscience. We meet again.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When the girl returned to his side, she was trembling. He wanted to strike her for her weakness, as he would have in his former life. Now, he doubted he could lift his arm on his own. Shameful as it was, he relied on her. It wouldn’t do much good to put her off helping him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The rectory is downstairs.” She sniveled pathetically as she opened a door. Shag-carpeted steps led down into darkness. “I think that’s where they’ll keep us. It’s where they’ve been keeping me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mind raced, trying to piece together the information he remembered from his former life, and how it might apply to his current situation. “And who are ‘they’?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Monsters.” The word came out as less than a whisper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He wished he could push her down the stairs. Unfortunately, that would send him tumbling, as well. “Yes, vampires. I know. But who are they?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She shook her head. “I don’t know what you’re—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who are they? Who are they allies with? Are they the Fangs or the Celts or the Coveners?” He searched his memory for the names of other vampire gangs, and his heart seized in fear. “They’re not Movement?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What a stupid question. Of course they weren’t the Movement. It wouldn’t make sense for the Voluntary Vampire "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Extinction")])]), _vm._v(" Movement to bring vampires back from the dead.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unless his new, human existence was some form of sadistic punishment they’d dreamed up. If it were, he could guess who’d moved his name to the top of that list.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl helped him down the stairs to a cinder block apartment with a cot, a reclining chair, a dented aluminum TV tray with a half-eaten microwave dinner and a copy of the TV Guide, turned to the crossword puzzle, atop it. A small bookshelf supported a television and a few books, with a bottle of holy water and a rosary nestled in the corner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cyrus gestured to the water. “Hide that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl propped him against the wall before moving to do his bidding. “Why?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Because there are a lot of vampires upstairs, and they apparently didn’t search this room thoroughly. Any potential weapon we can find would be nice to keep.” He frowned at her as she picked up the bottle and walked past him, not sparing him a glance. “What’s the matter with you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nothing.” The word was accompanied by a hysterical, terrified hiccup. “Aside from being kidnapped by vampires and watching my two best friends murdered.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He wrinkled his nose at the thought. “If your two best friends were a nun and a priest, I’d say something is definitely the matter with you. But I meant why won’t you look at me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This forced her to do so, her eyes wide behind a few slashes of mousy-brown hair. “Be-because you’re naked.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It had been a long, long while since he’d had a good laugh at another’s expense. He thoroughly enjoyed laughing now, though he wobbled precariously against the cinder blocks at his back. “Oh, let me guess. You’re a sister, too, Sister?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She blushed as if the thought was preposterous. “No.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s a shame. I always found nuns to be the most fun. They’d all say no at first, but they’d be begging for it by the time I was through.” He shrugged and ignored her sob of horror. “I want to use the toilet and have a bath. You’ll have to help me. And then you can find some of the preacher’s clothes for me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What if they come down here?” She clutched his arm, apparently more afraid of their captors than his naked flesh.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’d suggest you drop the innocent act quickly. They’re more likely to let you live if you’re an active participant.” He shook her off, then promptly fell to the floor. He couldn’t stand the sound of her sharp, pitying gasp, so he tried to crawl.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let me help you,” she said quietly, kneeling at his side. And, because he was so damn weak, he let her assist him to his feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The bathroom was small, nothing like he was used to in his former life. But it had a bathtub, and the hideous orange shag carpet didn’t creep past the doorway. If it weren’t for the unevenly patterned tile floor, he’d almost say this was his favorite room yet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He endured the humiliation of another human helping him to use the toilet, then the girl set about turning on the rusted taps to fill the gleaming, porcelain tub.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She helped him into the water, and he hissed at the sting of it on his skin. She didn’t seem to care, her thin arms quaking with obvious exhaustion as she lowered him into the tub. “Will you be able to sit up?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am seated in a veritable cauldron of scalding water. I’ll endeavor to keep the rest of myself out of it, yes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She left him alone with his thoughts then, and there were a fair amount of them. Too exhausted to do little more than think, he considered the steps he would take now. First, he’d find out who had done this to him. Then he’d contact his father. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Unless it is Father who has done this.")])]), _vm._v(" That wasn’t as far-fetched as he’d like to imagine. What didn’t make sense was why dear old dad would bring him back as a human.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Of course, it might not have been his father at all. Cyrus prided himself on being a well-known name among vampires. Perhaps a fanatical group had raised him in hopes of fame or a favor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Or for a sacrifice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It wasn’t unheard of. He’d helped his father sacrifice vampires for centuries. But the key word was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("vampire.")])]), _vm._v(" Why was he "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("human?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had just gotten comfortable when a soft knock sounded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What?” He picked up the nearest object—a bar of soap—and flung it at the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Mouse came in with a pile of neatly folded clothes. “Father Bart was shorter than you. And fatter.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Pick up the soap.” Cyrus watched as she bent to retrieve it. Nothing to write home about, he decided, tilting his head to study her backside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In the past, he would have fed off her. She had long, slender legs that would have been heaven wrapped around him, and hair just the right length to pull and bare her throat for a bite. But her face was too innocent, her whole manner too timid. Her faded cotton sundress told endless tales of trips to Wal-Mart in Daddy’s pickup truck, Garth Brooks blaring over the roar of the road through the open windows.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The vampire Cyrus would have taken his pleasure and her blood in one night, and she wouldn’t have lived to see the dawn.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He missed blood more now than when he’d drifted aimlessly on the other side of the veil. He didn’t want to think of it anymore.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she stood and handed him the soap, he snatched it away. “What are those?” he snapped, gesturing to the clothes. “Polyester?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, read the bloody tags. Are you completely worthless?” He grabbed the shirt from the top of the pile and scanned the care instructions before flinging it aside in disgust. “I only wear natural fiber.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl nodded uncertainly. “I don’t think Father Bart had any—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The dead priest is not my fucking problem!” He slammed his fists down on the water, sloshing it over the sides of the tub.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Mouse shrank away, screaming. It lifted Cyrus’s spirits considerably to see the girl frightened.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Get out. If you can’t find anything suitable for me, you’ll have to ask those morons upstairs.” He leaned against the curved back of the tub and closed his eyes, savoring the girl’s litany of pleas as she cowered on the floor.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max arrived five hours later. I was buried beneath the covers on Nathan’s bed, clinging to his scent like a life raft and trying to ignore the bedside radio he always kept on. The classic rock station was in the middle of a Fleetwood Mac Rock Block. “Gypsy” was just finishing up when I heard the front door burst open.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Carrie?” Something heavy hit the floor in the living room. Probably the duffel bag Max always carried with him. Loud footsteps ran down the hall and I climbed from beneath the blankets in time to see him skid to a stop at the doorway.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What’s going on? Where’s Nathan?” Max scanned the room as if he’d see him there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gone.” I don’t know if it was my relief at finally having an ally in my nightmare or if the reality of the situation had finally set in, but my voice cracked and tears rolled down my face. “He’s just gone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, God. Carrie.” Max dropped to the bed and put his arms around me. His jacket smelled like leather and cigarette smoke where I buried my face against his shoulder. He only held me a moment before he pulled away. Making a motion of a stake going through his heart, he asked quietly, “Gone?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I shook my head and wiped my eyes. “Not like that. He was here. His body was here. But he wasn’t.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He was possessed?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not exactly.” How could I explain it? “There wasn’t anything of Nathan left at all. Could you turn off that radio?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max nodded and fumbled with the alarm clock until “Go Your Own Way” cut out in the middle. “I hate that song, anyway.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I covered my eyes, and he pulled me into his arms again. No matter how good the physical comfort felt, it did nothing to dull the ache in my heart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What happened?” he asked softly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I didn’t let go of him. “I felt it through the blood tie. Something was wrong. So I went downstairs.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When I couldn’t finish, he shushed me and patted my back. For all his come-ons and attitude, Max was actually a very understanding man. “Listen, I’m going to go downstairs and look around. You stay up here where you’ll be safe.” He leaned back and looked me in the eye. “Okay?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I followed him to the living room and watched him pull some stakes from his bag. “Be careful.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked up, the most fake smile I’d ever seen on his face. “I can take care of myself, Doctor.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, not that. I mean, if Nathan is down there…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max followed my gaze to the stake in his hand. When our eyes met, his expression broke my heart more than it already was. “Give me a little credit, Carrie.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sorry.” Dangerously close to tears, I turned away and pretended to be interested in something on one of the many bookshelves lining the wall. Only when I heard the door click softly closed behind me did I allow myself to wipe my eyes. When I looked up, the spines of Nathan’s ridiculously large collection of books confronted me. When I glanced away, I saw his chair, his shoes. A half-finished mug of blood atop a stack of notebooks. All of the components were there, all of the little parts that made Nathan’s life, waiting for him to return to them. It made his absence more real somehow, and mocked my pain. If we never found Nathan, these little reminders of him would remain for me to deal with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I don’t know how long I stood there staring at the photo, but when the rattle of the doorknob heralded Max’s return, his speed surprised me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shrugged off his jacket and tossed it over the back of the chair. “There’s nothing. Just a lot of really nasty-smelling blood. I’m assuming that was his?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I nodded, not trusting myself to speak.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There’s nothing else we can do tonight.” He rubbed the back of his neck and swore. “Tell me what happened.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The symbols.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There were marks.” I scrambled for a notebook and pen I spied on the perpetually cluttered coffee table. “Strange things he’d carved all over his body.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Carved? As in cut?” Max came around the chair and stood beside me, looming hopefully over my shoulder as I scribbled what I could remember of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I think they were sigils, or something.” I closed my eyes, but couldn’t get a clear picture. “It all looked like random angles with circles on the end.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When I handed him the paper, he frowned and traced his fingers over the symbols. “You’re sure this is right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, I didn’t take a picture of them, but when a bleeding, naked man with funky writing carved all over his body is pinning you to the ground, you have other things on your mind.” I chewed my lip and pointed to the page. “What do you think?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He attacked you?” Max’s eyes darted over me, looking for signs of injury. “Are you okay?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah.” I hadn’t thought to mention the attack, and the omission seemed ridiculous now. I almost laughed at my stupidity. “He stopped. I think…I think he knew it was me. He smelled me and then he just…stopped.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max considered the information for a moment, then turned back to the page. “Does Nathan speak any other languages?” He pulled his cell phone from his pocket. “Aramaic, Hindi, Greek? Something with letters that look different from ours?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I shook my head. “Gaelic, from childhood, but the letters look the same. He slips into it sometimes when he’s tired or drunk, but—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max chuckled. “I’ll file that away for future reference.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The fact he believed Nathan "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" a future reassured me a little. I sat on the couch while Max punched up a number on his phone. “Who are you calling?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Movement,” Max said casually as if he wasn’t standing in the home of two fugitive vampires.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I lunged for the phone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He yelped in surprise and jumped back. “Hey, what are you doing?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You can’t call the Movement,” I whispered fiercely as though they could hear me. “They’ll kill us.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They’ll want to know something happened to Nathan. Besides, who’s going to help us? The oh-so-reliable spell books downstairs?” He turned away to speak into the phone. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hola,")])]), _vm._v(" baby. It’s Harrison. Get me Anne.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("My heart pounded in my chest as I stood helplessly by while Nathan’s only friend turned Judas.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Anne, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cómo está?")])]), _vm._v(" It’s Harrison.” He paused, then burst out with a hearty laugh.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("How could he do this?")])]), _vm._v(" I seethed, tuning out his conversation. Nathan had quit the Voluntary Vampire Extinction Movement when he’d sired me. We’d been flying under the radar ever since, and now Max was going to bring us to their attention?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gotcha.” His smile widened. “We’ll be on the plane at sunset.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Plane?” I barely held the word in until he’d hung up the phone. “Where are you going?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("We")])]), _vm._v(" are going to Movement headquarters. In Madrid,” he added casually as if location would be my prime concern.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Excuse me? We? You expect me to march into a building full of assassins who’ve been commanded to kill me on sight?” I shook my head emphatically. “No way.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max laughed. “You give yourself a lot of credit, you know that? There are thousands of renegade vampires roaming the earth. You’re a two-month-old who killed her sire. Even if you mentioned your name to every person in the place, I bet you wouldn’t come across one vampire who recognized it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you told them about Nathan.” I gestured to the phone in his hand. “They’ll know to look out for him, then.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max tossed the cell onto the coffee table and sat beside me. “He was a good assassin. They’re upset that he’s left the fold, but they’re not going to put a bounty on him unless he really steps over the line. There are way too many vampires out there doing worse damage to humankind.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I knew it was true. Nathan had told me as much. If they’d wanted us dead, we would have been staked within the week after I’d killed Cyrus. “Over the line?” My heart jumped into my throat. “Like?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Like killing someone or making a new vampire.” Max tried to maintain a neutral expression, but it grew more serious by degrees. “Listen, I’m not going to tell you this is an ideal situation. Nathan’s in grave danger. If I thought we had the resources to help him ourselves, I would never have involved the Movement.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You won’t let them kill him, will you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max shook his head grimly, but a steel band of worry clamped around my heart. “There’s something you’re not telling me,” I murmured.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max sighed heavily. “We’ve been monitoring the Soul Eater. There’s been…activity.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Of course there had been. Jacob Seymour, Cyrus’s father and Nathan’s sire, had haunted my nightmares ever since I’d first seen him at Cyrus’s Vampire New Year party. He cannibalized other vampires, consuming their blood and their souls to stay alive after years of maniacal acquisition of power had taken their toll on his metabolism. Most of the year he slept safe in his coffin with a full retinue of guards, but a Movement strike team had thrown his feeding schedule off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What kind of activity?” My fingernails bit into my palms as I clenched my fists. I wanted to scream, “Just get it over with! Tell me what’s going on!” But I couldn’t treat Max that way. He was trying to help me by breaking the news gently. He didn’t know it was like pulling a Band-Aid off slowly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“His known fledglings have gone missing. Even Movement guys. Carrie, there’s a reason the Soul Eater is so weak. He’s made, like, a fledgling a year for five centuries. Now they’re all disappearing.” Max shrugged helplessly. “And he’s getting stronger.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If I’d thought I’d hit bottom before, I’d had no idea. At Max’s words, the bottom truly dropped out. “You don’t think…” I couldn’t say it. There was only one way the Soul Eater grew stronger: consuming a vampire’s blood and soul.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, I only know what they tell me,” he said, trying to sound encouraging, I’m sure. “But this thing…listen, there’s only one person who’s going to be able to tell us what’s wrong with Nathan. Unfortunately, she’s a little dangerous. That’s why the Movement has her.” He paused, cursed and ran a hand through his short blond hair. “I don’t like the plan, but they think it’s the best idea, and frankly, we don’t have anything else to go on.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a shock, I realized my night hadn’t started out this way. I’d gotten up, spoken to Nathan, gone for a walk, with no suspicion that another hardship was waiting for us. The unfairness of the situation crushed me. All I wanted was Nathan, to have him with me, to tell me everything was all right. I tried the blood tie, but I felt nothing. Pain, so powerful I couldn’t express it with a sound, forced its way from my body, my mouth frozen open in a silent scream. I wrapped my arms around my middle and tried to stand, only to collapse to my knees on the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Max was beside me in a heartbeat, grabbing my upper arms to haul me upright and onto the couch. He put his arms around me, and I collapsed against him. His cotton T-shirt was comforting against my cheek, and for a moment I let myself pretend it was Nathan holding me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then I pushed the fantasy away. It would never stop hurting if I didn’t face reality. Nathan was gone, maybe forever.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know what I’m going to do,” I sobbed, more to myself than to Max.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His voice was thick as he struggled to keep the emotion out of it. “I know what you’re going to do. You’re going to get through tonight and probably tomorrow, then we’re going to get on that plane to Madrid. We’ll meet with the Movement, do some sightseeing, get gloriously drunk and catch a flamenco show. Sound good?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How can you joke at a time like this?” I wiped my nose pathetically on the back of my hand, glaring at him. “What if we don’t get Nathan back?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This isn’t the worst thing that’s ever happened to Nathan. He’ll come out of this.” Max hesitated. “I haven’t told anyone this…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I sat up. “Haven’t told anyone what?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked away. “I don’t know if it will help you if I do tell you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s worth a shot.” Nothing he could say would make things worse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My sire died.” Before I could make any attempt at condolences, he rushed to speak again. “About ten years ago. He wasn’t Movement. I wasn’t either, at the beginning. I was living with him—nothing gay or anything—and I started talking to this girl. She was an assassin. I didn’t know. She used me to get to him, then she gave me a choice. I could join the Movement or die. After I saw what she’d done to Marcus—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You don’t have to go on,” I whispered. The pain in his voice overwhelmed me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He nodded and smiled as though he was embarrassed to be so emotionally exposed. “I still miss him. Sometimes I think if I could just hear his voice…But for the most part, I’ve gotten better.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I wanted to say “I can’t imagine,” or “That must have been awful,” but I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("could")])]), _vm._v(" imagine and it "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" awful. That was why he’d told me. If he could survive losing his sire, I could survive this separation from Nathan. Unfortunately, with that came the implied reassurance I could survive Nathan’s death. I didn’t want to think about it, so I didn’t say anything, and leaned against Max again. Like this, I could rest secure in the familial love that cements good friendships.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We’re going to get him back, Carrie. Nathan’s too big a pain in my ass to be gone for long. I’m not that lucky.” He gave me a quick squeeze with the arm draped around my shoulders.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Our morose conversation died without a fight as we retreated into ourselves. Max fell asleep, leaning against me on the couch. I’m sure we made a cheerful picture: two wounded souls, both relying on the other to hold them up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Outside, the sun came up. Wherever Nathan was, I hoped he was okay.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb6f108","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bloodtiesbooktwopossession_ch02.vue
// module id = 75
// module chunks = 0